import { render } from "./menu-left.vue?vue&type=template&id=4c7a462a"
import script from "./menu-left.vue?vue&type=script&lang=js"
export * from "./menu-left.vue?vue&type=script&lang=js"

import "./menu-left.vue?vue&type=style&index=0&id=4c7a462a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__